var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"items":_vm.items,"item-text":"name","item-value":"id","error-messages":_vm.errors,"outlined":"","dense":"","label":_vm.$t('Country')},on:{"input":function($event){return _vm.$emit('input', _vm.value)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }